import type { Prices } from "@b2bportal/core-types";

// override this in tenants
export const EMPTY_PRICES: Prices = {
  fiat: {
    currencyCode: "SGD",
    currencySymbol: "SGD",
    value: 0,
  },
  accountSpecific: {},
};
